/**
 * Created by Administrator on 2016/11/22.
 */

import TapHoldCopyComponent from 'components/base-ui/tap-hold-copy';
import WarningBubbleComponent from 'components/base-ui/warning-bubble';
import { isPC } from '@/utils/environment';
import { computedDistance } from 'utils';
export default (Vue) => {
  let tapHoldCopyEl, // 长按复制组件容器
    timeout, // 长按复制长按计时器
    oldHashChange, // app原始hashChange事件
    firstTouchEnd, // 用于判断拖拽时是否注销事件
    startPosition, //初始点击时位置
    currentPosition, //move时位置
    windowSize, // app窗口大小
    warningBubbleEl, // 存储warning-bubble
    passiveSupported; // 是否passive对象

  if (!windowSize) {
    windowSize = {};
    if (window.innerWidth) windowSize.width = window.innerWidth;
    else if (document.body && document.body.clientWidth) windowSize.width = document.body.clientWidth;
    if (window.innerHeight) windowSize.height = window.innerHeight;
    else if (document.body && document.body.clientHeight) windowSize.height = document.body.clientHeight;
  }

  try {
    let options = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        passiveSupported = true;
      },
    });
    window.addEventListener('test', null, options);
  } catch (err) {}

  function createEventOptions(capture) {
    return passiveSupported ? { passive: false, capture } : capture;
  }

  // 计算元素出现位置
  function computedPosition($e) {
    let top, left;
    if ($e.touches && $e.touches[0]) {
      top = $e.touches[0].pageY;
      left = $e.touches[0].pageX;
    } else {
      top = $e.pageY;
      left = $e.pageX;
    }
    let targetTop;
    let targetLeft;
    targetTop = top < 50 ? top : top - 50; // top - 50 < 0
    targetLeft = left + 88 >= windowSize.width ? left - 88 : left;
    return {
      top: targetTop + 'px',
      left: targetLeft + 'px',
    };
  }

  Vue.directive('touch', {
    bind: function (el, binding, vnode) {
      var touchType = binding.arg; //传入的模式 longTap swipeRight swipeLeft swipeTop swipeDowm Tap
      var timeOutEvent = 0;
      var direction = '';
      //滑动处理
      var startX, startY;

      //返回角度
      function GetSlideAngle(dx, dy) {
        return (Math.atan2(dy, dx) * 180) / Math.PI;
      }

      //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      function GetSlideDirection(startX, startY, endX, endY) {
        var dy = startY - endY;
        var dx = endX - startX;
        var result = 0;

        //如果滑动距离太短
        if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
          return result;
        }

        var angle = GetSlideAngle(dx, dy);
        if (angle >= -45 && angle < 45) {
          result = 'swiperight';
        } else if (angle >= 45 && angle < 135) {
          result = 'swipeup';
        } else if (angle >= -135 && angle < -45) {
          result = 'swipedown';
        } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
          result = 'swipeleft';
        }

        return result;
      }

      el.addEventListener(
        'touchstart',
        function (ev) {
          startX = ev.touches[0].pageX;
          startY = ev.touches[0].pageY;

          //判断长按
          timeOutEvent = setTimeout(() => {
            timeOutEvent = 0;
            if (touchType === 'press') {
              binding.value();
            }
          }, 500);
        },
        false
      );

      el.addEventListener('touchmove', function (ev) {
        clearTimeout(timeOutEvent);
        timeOutEvent = 0;
      });

      el.addEventListener(
        'touchend',
        function (ev) {
          var endX, endY;
          endX = ev.changedTouches[0].pageX;
          endY = ev.changedTouches[0].pageY;
          direction = GetSlideDirection(startX, startY, endX, endY);

          clearTimeout(timeOutEvent);

          switch (direction) {
            case 0:
              break;
            case 'swipeup':
              if (touchType === 'swipeup') {
                binding.value();
              }

              break;
            case 'swipedown':
              if (touchType === 'swipedown') {
                binding.value();
              }

              break;
            case 'swipeleft':
              if (touchType === 'swipeleft') {
                binding.value();
              }

              break;
            case 'swiperight':
              if (touchType === 'swiperight') {
                binding.value();
              }

              break;
            default:
          }
        },
        false
      );
    },
  });

  Vue.directive('tapholdcopy', {
    bind(el, binding) {
      const TapHoldCopy = Vue.extend(TapHoldCopyComponent);

      if (!tapHoldCopyEl) {
        tapHoldCopyEl = new TapHoldCopy({
          el: document.createElement('div'),
        });
        document.body.appendChild(tapHoldCopyEl.$el);
      }

      function clickEvent($event) {
        if ($event.target.className !== 'thc-body') {
          $event.stopPropagation();
        }
        tapHoldCopyEl.show = false;
      }

      function touchMoveEvent() {
        if (firstTouchEnd) {
          tapHoldCopyEl.show = false;
        }
      }

      // 注销事件和watcher
      function removeEvent() {
        tapHoldCopyEl.watcher && tapHoldCopyEl.watcher();
        tapHoldCopyEl.watcher = undefined;
        document.body.removeEventListener('click', clickEvent, true);
        document.body.removeEventListener('touchmove', touchMoveEvent, true);

        if (oldHashChange) {
          window.onhashchange = oldHashChange;
        } else {
          window.onhashchange = null;
        }
      }

      el.addEventListener(
        'touchstart',
        function ($e) {
          startPosition = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          timeout = setTimeout(() => {
            firstTouchEnd = false;

            // 给body绑定事件使用户点击其他区域能隐藏长按复制元素
            if (!tapHoldCopyEl.show) {
              oldHashChange = window.onhashchange;
              document.body.addEventListener('click', clickEvent, true);
              document.body.addEventListener('touchmove', touchMoveEvent, true);
            }

            tapHoldCopyEl.position = computedPosition($e);
            tapHoldCopyEl.content = binding.value;
            tapHoldCopyEl.show = true;

            // 修改onhashchange事件确保返回时隐藏长按复制元素
            window.onhashchange = function () {
              oldHashChange && oldHashChange();
              tapHoldCopyEl.show = false;
            };

            // 仅当watcher销毁之后才重新创建watcher
            if (!tapHoldCopyEl.watcher) {
              tapHoldCopyEl.watcher = tapHoldCopyEl.$watch('show', (val) => {
                if (!val) {
                  // 隐藏元素时销毁绑定给body的click和touchmove事件，并还原onhashchange
                  removeEvent();
                }
              });
            }
          }, 1000);
        },
        false
      );

      el.addEventListener(
        'touchend',
        function () {
          clearTimeout(timeout);
          firstTouchEnd = true;
        },
        false
      );

      el.addEventListener(
        'touchmove',
        function ($e) {
          currentPosition = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          if (computedDistance(startPosition, currentPosition) > 5) {
            clearTimeout(timeout);
          }
        },
        false
      );
    },
  });

  // 长按指令，传入一个方法或包含handle和time的对象
  Vue.directive('long-press', {
    bind(el, binding) {
      let handle,
        time = 1000,
        start,
        current,
        startTime,
        endTime,
        oldOnContextMenu;
      if (typeof binding.value === 'object') {
        handle = binding.value.handle;
        time = binding.value.time || 800;
      } else {
        handle = binding.value;
      }
      el.style.webkitTouchCallout = 'none';
      el.addEventListener(
        'touchstart',
        function ($e) {
          // 禁止默认事件，避免弹出复制按钮
          startTime = new Date().getTime();

          // 暂时保存浏览器默认的长按菜单事件
          if (document.oncontextmenu) {
            oldOnContextMenu = document.oncontextmenu;
            // 修改浏览器默认的长按菜单事件
            document.oncontextmenu = (e) => {
              e && e.preventDefault();
              oldOnContextMenu && oldOnContextMenu();
            };
          } else {
            document.oncontextmenu = (e) => {
              e && e.preventDefault();
            };
          }

          start = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          timeout = setTimeout(() => {
            handle && handle($e);
          }, time);
        },
        createEventOptions(false)
      );

      el.addEventListener(
        'touchend',
        function ($e) {
          endTime = new Date().getTime();
          clearTimeout(timeout);

          // 当touch事件超过200ms时取消click事件
          if (endTime - startTime >= 200) {
            $e.preventDefault();
          }

          // 还原浏览器默认长按菜单事件
          // undefined 也要还原
          document.oncontextmenu = oldOnContextMenu;
          oldOnContextMenu = undefined;
        },
        createEventOptions(false)
      );

      // 当手指轻微抖动时不移除timeout
      el.addEventListener(
        'touchmove',
        function ($e) {
          current = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          if (computedDistance(start, current) > 5) {
            clearTimeout(timeout);
          }
        },
        createEventOptions(false)
      );
    },
  });

  Vue.directive('focus', {
    inserted: function (el, binding) {
      el.focus();
    },

    update: function (el, binding) {
      //
      if (binding.value) {
        // el.getElementsByTagName('input')[0].focus()
        if (el.getElementsByTagName('textarea').length > 0) {
          el.getElementsByTagName('textarea')[0].focus();
        } else if (el.getElementsByTagName('input').length > 0) {
          el.getElementsByTagName('input')[0].focus();
        }
      }
    },
  });

  Vue.directive('warning-bubble', {
    bind(el, binding) {
      const WarningBubble = Vue.extend(WarningBubbleComponent);

      if (!warningBubbleEl) {
        warningBubbleEl = new WarningBubble({
          el: document.createElement('div'),
        });
        document.body.appendChild(warningBubbleEl.$el);
      }

      function clickEvent($event) {
        if ($event.target.className !== 'warning-bubble') {
          $event.stopPropagation();
        }
        warningBubbleEl.show = false;
      }

      function touchMoveEvent() {
        warningBubbleEl.show = false;
      }

      // 注销事件和watcher
      function removeEvent() {
        warningBubbleEl.watcher && warningBubbleEl.watcher();
        warningBubbleEl.watcher = undefined;

        document.body.removeEventListener('click', clickEvent, true);
        document.body.removeEventListener('touchmove', touchMoveEvent, createEventOptions(true));

        if (oldHashChange) {
          window.onhashchange = oldHashChange;
        } else {
          window.onhashchange = null;
        }
      }

      el.attributes.warningBubbleContent = binding.value.warningBubbleContent;

      el.addEventListener(
        'click',
        function ($e) {
          if (!el.attributes.warningBubbleContent) return;
          startPosition = {
            top: $e.pageY,
            left: $e.pageX,
          };
          // 给body绑定事件使用户点击其他区域能隐藏长按复制元素
          if (!warningBubbleEl.show) {
            oldHashChange = window.onhashchange;
            document.body.addEventListener('click', clickEvent, true);
            document.body.addEventListener('touchmove', touchMoveEvent, createEventOptions(true));
          }

          let position = computedPosition($e);

          if (binding.value.bottom) {
            warningBubbleEl.bottom = binding.value.bottom;
            warningBubbleEl.top = '';
          } else {
            warningBubbleEl.top = binding.value.top || position.top;
            warningBubbleEl.bottom = '';
          }

          if (binding.value.left) {
            warningBubbleEl.left = binding.value.left;
          }

          // warningBubbleEl.left = position.left
          warningBubbleEl.content = el.attributes.warningBubbleContent;
          warningBubbleEl.show = true;

          // 修改onhashchange事件确保返回时隐藏长按复制元素
          window.onhashchange = function () {
            oldHashChange && oldHashChange();
            warningBubbleEl.show = false;
          };
          const hideBubble = (event) => {
            warningBubbleEl.show = false;
            document.body.removeEventListener('touchmove', hideBubble);
          };
          document.body.addEventListener('touchmove', hideBubble);
          // 仅当watcher销毁之后才重新创建watcher
          if (!warningBubbleEl.watcher) {
            warningBubbleEl.watcher = warningBubbleEl.$watch('show', (val) => {
              if (!val) {
                // 隐藏元素时销毁绑定给body的click和touchmove事件，并还原onhashchange
                removeEvent();
              }
            });
          }
        },
        false
      );
    },
    update(el, binding) {
      el.attributes.warningBubbleContent = binding.value.warningBubbleContent;
    },
  });

  Vue.directive('highlight', {
    update: function (el, binding) {},
    componentUpdated: function (el, binding, vnode, oldVnode) {
      var re = new RegExp(binding.value, 'i');

      if (el.innerText.search(re) != -1) {
        var reResult = new RegExp('(' + binding.value + ')', 'gi');
        var objResult = document.createElement('span');
        objResult.innerHTML = el.innerText.replace(reResult, '<span style=\'color: red;\'>$1</span>');
        el.innerHTML = objResult.innerHTML;
      }
    },
    inserted: function (el, binding) {},
  });

  // 添加一个指令，将元素直接渲染到body上
  Vue.directive('body', {
    inserted(el) {
      document.body.appendChild(el);
    },
    unbind(el) {
      el.parentNode === document.body && document.body.removeChild(el);
    },
  });

  Vue.directive('toast', {
    bind(el, { value, arg, modifiers }) {
      if (value) {
        if (arg === 'readOnly' || modifiers['readOnly']) {
          el.onclick = function () {
            Vue.$handPlugin.toast.show(window.$t('other-1.key37', { cm: '该内容不可编辑' }));
          };
        }
      }
    },
    update(el, { value, oldValue, arg, modifiers }) {
      if (!value && el.onclick != null) {
        el.onclick = null;
      } else if (value) {
        if (arg === 'readOnly' || modifiers['readOnly']) {
          el.onclick = function () {
            Vue.$handPlugin.toast.show(window.$t('other-1.key37', { cm: '该内容不可编辑' }));
          };
        }
      }
    },
    unbind(el) {
      if (el.onclick != null) {
        el.onclick = null;
      }
    },
  });

  /**
   * 点击反馈
   * 目前支持三个值['deep-filter', 'deep-background', 'weak-filter']
   * 依次触发'-feedback-start', '-feedback-active', '-feedback-end'
   * 样式定义参考 click-feedback.scss
   *
   * 默认weak-filter
   */
  let activeTimer;
  let activePrefix;
  let activeEl;
  let touchStartTimer;
  Vue.directive('click-feedback', {
    bind(el, binding = {}, vnode) {
      let { value: classPrefix = 'weak-filter' } = binding;
      if (!classPrefix) return;
      let start, current; // 用于防止手指误触导致的touchmove事件
      el.addEventListener(
        'touchstart',
        ($e) => {
          if (activeEl) {
            ['-feedback-start', '-feedback-active', '-feedback-end'].forEach((key) => {
              activeEl.classList.remove(`${activePrefix}${key}`);
            });
          }
          start = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          touchStartTimer = setTimeout(() => {
            // 用于move时取消
            let { classList } = el;
            classList.add(`${classPrefix}-feedback-start`);
            activeTimer = setTimeout(() => {
              classList.remove(`${classPrefix}-feedback-start`);
              classList.add(`${classPrefix}-feedback-active`);
            }, 100);
            activeEl = el;
            activePrefix = classPrefix;
          });
        },
        createEventOptions(true)
      );

      el.addEventListener(
        'touchmove',
        ($e) => {
          current = {
            top: $e.touches[0].pageY,
            left: $e.touches[0].pageX,
          };
          if (touchStartTimer && !activePrefix && computedDistance(start, current) > 5) {
            clearTimeout(touchStartTimer);
          }
        },
        createEventOptions(true)
      );

      el.addEventListener(
        'touchend',
        () => {
          let { classList } = el;
          // 点击过快时会导致touchStartTimer未执行就直接触发touchend，就会造成activeTimer在最后执行，所以要清除touchStartTimer
          if (touchStartTimer) {
            clearTimeout(touchStartTimer);
          }
          if (
            classList.contains(`${classPrefix}-feedback-start`) ||
            classList.contains(`${classPrefix}-feedback-active`)
          ) {
            classList.remove(`${classPrefix}-feedback-start`);
            classList.remove(`${classPrefix}-feedback-active`);
            classList.add(`${classPrefix}-feedback-end`);
            if (activeTimer) {
              clearTimeout(activeTimer);
            }
            setTimeout(() => {
              classList.remove(`${classPrefix}-feedback-active`);
              classList.remove(`${classPrefix}-feedback-end`);
            }, 100);
            activePrefix = undefined;
            activeEl = null;
          }
        },
        createEventOptions(true)
      );
    },
    componentUpdated(el) {
      if (activeEl && activePrefix) {
        if (el === activeEl && !el.classList.contains(`${activePrefix}-feedback-active`)) {
          el.classList.add(`${activePrefix}-feedback-active`);
        }
      }
    },
  });

  /**
   * -webkit-overflow-scrolling:touch
   * ios上 手指按住屏幕上下拖动 这个事件触发的对象是整个webview容器，容器自然会被拖动，剩下的部分会变成空白
   * 逻辑处理： 顶部只可向下滑 底部只可向上滑 否则 preventDefault处理
   * !! 不存在固定元素时 可不使用该指令处理
   *
   */
  let allowScrollUp;
  let allowScrollDown;
  let scrollBeginY;
  Vue.directive('ios-scroll-fix', {
    bind: function (el) {
      el.addEventListener('touchstart', (ev) => {
        allowScrollUp = el.scrollTop > 0;
        allowScrollDown = el.scrollTop < el.scrollHeight - el.clientHeight;
        scrollBeginY = ev.touches[0].pageY;
      });
      el.addEventListener('touchmove', (ev) => {
        const { pageY } = ev.touches[0];
        let up = pageY > scrollBeginY;
        let down = pageY < scrollBeginY;
        scrollBeginY = pageY;
        if ((up && allowScrollUp) || (down && allowScrollDown)) {
          ev.stopPropagation();
        } else {
          ev.cancelable && ev.preventDefault();
        }
      });
    },
  });
  // x轴滚动
  Vue.directive('navigator-scroll-x', {
    bind: function (el) {
      if (isPC()) {
        return !1;
      }
      let isMove = false;
      let warpScrollLeft = 0;
      let initPosX = 0;
      el.addEventListener('touchstart', ($event) => {
        let touch = $event.touches[0];
        initPosX = touch.pageX || touch.clientX;
        warpScrollLeft = el.scrollLeft; // 容器滚动距离
        isMove = false;
      });
      el.addEventListener('touchmove', ($event) => {
        $event.preventDefault();
        $event.stopPropagation();
        let touch = $event.touches[0],
          currentPosX = touch.pageX || touch.clientX;
        if (currentPosX - initPosX !== 0) {
          isMove = true;
          el.scroll(warpScrollLeft - currentPosX + initPosX, 0);
        }
      });
      el.addEventListener('touchend', (ev) => {
        if (isMove) {
          ev.preventDefault();
          ev.stopPropagation();
        }
      });
    },
    inserted(el) {
      if (isPC()) {
        el.classList.add('overflow-x');
      }
    },
  });
  // disable ios bounce
  Vue.directive('ios-disable-scroll', {
    bind: function (el) {
      el.addEventListener('touchmove', (ev) => {
        ev.preventDefault();
      });
    },
  });
};
